// Author Lin
// Date 2021-12-07 18:13:10

class MintalMesPrdSmeltingElectrodeWeightChange {
        constructor({
                id = null,
                recordTime = '',
                locationId = '',
                locationName = '',
                furnaceId = '',
                furnaceName = '',
                shiftId = '',
                shiftName = '',
                alphaPressureTime = '',
                alphaPressureNumber = '',
                alphaMaxWeight = '',
                alphaDiff = '',
                alphaCoverTemp = '',
                alphaBottomTemp = '',
                bravoPressureTime = '',
                bravoPressureNumber = '',
                bravoMaxWeight = '',
                bravoDiff = '',
                bravoCoverTemp = '',
                bravoBottomTemp = '',
                charliePressureTime = '',
                charliePressureNumber = '',
                charlieMaxWeight = '',
                charlieDiff = '',
                charlieCoverTemp = '',
                charlieBottomTemp = '',
                alkalinity = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.recordTime = recordTime;
            this.locationId = locationId;
            this.locationName = locationName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.shiftId = shiftId;
            this.shiftName = shiftName;
            this.alphaPressureTime = alphaPressureTime;
            this.alphaPressureNumber = alphaPressureNumber;
            this.alphaMaxWeight = alphaMaxWeight;
            this.alphaDiff = alphaDiff;
            this.alphaCoverTemp = alphaCoverTemp;
            this.alphaBottomTemp = alphaBottomTemp;
            this.bravoPressureTime = bravoPressureTime;
            this.bravoPressureNumber = bravoPressureNumber;
            this.bravoMaxWeight = bravoMaxWeight;
            this.bravoDiff = bravoDiff;
            this.bravoCoverTemp = bravoCoverTemp;
            this.bravoBottomTemp = bravoBottomTemp;
            this.charliePressureTime = charliePressureTime;
            this.charliePressureNumber = charliePressureNumber;
            this.charlieMaxWeight = charlieMaxWeight;
            this.charlieDiff = charlieDiff;
            this.charlieCoverTemp = charlieCoverTemp;
            this.charlieBottomTemp = charlieBottomTemp;
            this.alkalinity = alkalinity;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingElectrodeWeightChange();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.furnaceId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.shiftId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.shiftName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alphaPressureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.alphaPressureTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alphaPressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.alphaPressureNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alphaMaxWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.alphaMaxWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alphaDiff',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.alphaDiff',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alphaCoverTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.alphaCoverTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alphaBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.alphaBottomTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bravoPressureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.bravoPressureTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bravoPressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.bravoPressureNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bravoMaxWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.bravoMaxWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bravoDiff',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.bravoDiff',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bravoCoverTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.bravoCoverTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bravoBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.bravoBottomTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'charliePressureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.charliePressureTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'charliePressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.charliePressureNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'charlieMaxWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.charlieMaxWeight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'charlieDiff',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.charlieDiff',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'charlieCoverTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.charlieCoverTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'charlieBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.charlieBottomTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'alkalinity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.alkalinity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            shiftIdFilter : '',
            shiftNameFilter : '',
            alphaPressureTimeRteFilter : '',
            alphaPressureTimeLteFilter : '',
            alphaPressureNumberFilter : '',
            alphaMaxWeightFilter : '',
            alphaDiffFilter : '',
            alphaCoverTempFilter : '',
            alphaBottomTempFilter : '',
            bravoPressureTimeRteFilter : '',
            bravoPressureTimeLteFilter : '',
            bravoPressureNumberFilter : '',
            bravoMaxWeightFilter : '',
            bravoDiffFilter : '',
            bravoCoverTempFilter : '',
            bravoBottomTempFilter : '',
            charliePressureTimeRteFilter : '',
            charliePressureTimeLteFilter : '',
            charliePressureNumberFilter : '',
            charlieMaxWeightFilter : '',
            charlieDiffFilter : '',
            charlieCoverTempFilter : '',
            charlieBottomTempFilter : '',
            alkalinityFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'shiftNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.filter.shiftName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.shiftName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'alphaPressureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.alphaPressureTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'alphaPressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.alphaPressureNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'alphaMaxWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.alphaMaxWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'alphaDiff',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.alphaDiff',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'alphaCoverTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.alphaCoverTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'alphaBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.alphaBottomTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bravoPressureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.bravoPressureTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'bravoPressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.bravoPressureNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bravoMaxWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.bravoMaxWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bravoDiff',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.bravoDiff',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bravoCoverTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.bravoCoverTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bravoBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.bravoBottomTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'charliePressureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.charliePressureTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'charliePressureNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.charliePressureNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'charlieMaxWeight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.charlieMaxWeight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'charlieDiff',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.charlieDiff',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'charlieCoverTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.charlieCoverTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'charlieBottomTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.charlieBottomTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'alkalinity',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.alkalinity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeWeightChange.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingElectrodeWeightChange, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        